import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import FleetWebApi from "../Api/FleetWebApi";

const VirtualIdBypassLookup = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const [redirect, setRedirect] = useState(null);

  async function getCoreIDBypassVirtual(lookupId) {
    lookupId = lookupId.split(".").join("");
    
    // Bypass virtual ID logic - treat as core ID or serial only
    if (lookupId.length === 24 || lookupId.length === 18) {
      // Assume it's already a core ID, navigate directly with bypass flag
      setRedirect("/device/" + lookupId + "?bypassVirtual=true");
      return null;
    }
    
    // For other lengths assume serial numbers and look up core ID
    FleetWebApi.getDeviceCoreID(lookupId).then(
      (result) => {
        setRedirect("/device/" + result + "?bypassVirtual=true");
        return null;
      },
      (error) => {
        console.log(error);
        setRedirect("/device/" + lookupId + "?bypassVirtual=true");
        return null;
      }
    );
  }

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    getCoreIDBypassVirtual(value);
  };

  useEffect(() => {
    if (redirect !== null) {
      navigate(redirect);
    }
  }, [redirect, navigate]);

  return (
    <form onSubmit={handleSubmit} style={{ justifyContent: "center" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <TextField
          id="bypass-lookup"
          label="Serial / Core (No Virtual)"
          value={value}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          style={{ marginLeft: 5, marginRight: 5 }}
        />
        <Button
          variant="contained"
          type="submit"
          color="secondary"
          label="Submit"
          style={{ marginLeft: 5, marginRight: 5 }}
        >
          Submit
        </Button>
      </div>
    </form>
  );
};

export default VirtualIdBypassLookup;
